import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { formatNumber } from '@/lib/format'

interface PriceTagProps {
    price: number | null
    size?: 'default' | 'lg'
    showFrom?: boolean
    className?: string
}

export const PriceTag: FC<PriceTagProps> = ({ price, size = 'default', showFrom = false, className }): ReactNode => {
    if (price === null) {
        return (
            <p className={cn('text-sm font-medium text-muted-foreground', className)}>
                قیمت پس از مشاوره اعلام می‌شود
            </p>
        )
    }

    return (
        <p className={cn('flex flex-wrap items-baseline gap-x-1.5', className)}>
            {showFrom && (
                <span className='text-sm text-muted-foreground'>
                    از
                </span>
            )}

            <span className={cn('font-semibold text-foreground', size === 'lg' ? 'text-3xl' : 'text-lg')}>
                {formatNumber(price)}
            </span>

            <span className={cn('text-muted-foreground', size === 'lg' ? 'text-base' : 'text-sm')}>
                تومان
            </span>
        </p>
    )
}
